import {
  useAdminCredentials,
  useRevealCredential,
  useUpdateCredentials,
} from '../../../features/admin/use-admin-credentials'
import { VENDOR_KEYS, vendorBlock } from '../../../features/admin/vendors'
import { AdminPage, VendorEntry } from './admin-bits'

export function LedgerAdminCredentials() {
  const creds = useAdminCredentials()
  const update = useUpdateCredentials()
  const reveal = useRevealCredential()
  return (
    <AdminPage
      title="Credentials"
      standfirst="Vendor integration settings. Secrets stay masked until revealed, then hide again after thirty seconds."
      loading={creds.isLoading}
      error={!!creds.error}
    >
      {VENDOR_KEYS.map((v) => (
        <VendorEntry
          key={v}
          vendor={v}
          block={vendorBlock(creds.data, v)}
          pending={update.isPending && update.variables?.vendor === v}
          error={update.variables?.vendor === v ? update.error : null}
          onSave={(body) => update.mutate(body)}
          reveal={(vendor, field) => reveal.mutateAsync({ vendor, field })}
        />
      ))}
    </AdminPage>
  )
}
